export default __webpack_public_path__ + "static/media/shop.fbd95386.png";